<template>
  <div class="noData">{{ $t("pages.wording.noDataFind") }}</div>
</template>

<script>
export default {
  name: "NoData",
  data() {
    return {}
  }
}
</script>

<style scoped>
.noData  {
  width: 100%;
  text-align: center;
  font-size:  var(--content-font-size);
  line-height: var(--content-line-height);
  margin: 24px 0;
}
</style>
